const Define = {
  BG: "rs-bg-main rs-text-main-foreground",
  H_BG: "hover:rs-bg-main hover:rs-text-main-foreground",
  BORDER: "rs-border rs-border-main/15",
  ROUND: "rs-rounded-md",
};

export default Define;
